import * as api from '../../services/signinwall'

export const FETCH_SIGNINWALLMESSAGERECENT= 'FETCH_SIGNINWALLMESSAGERECENT';





export const fetchSigninwallMessageRecent = (params, pagination, sort, extra) => {

    return {
        type: FETCH_SIGNINWALLMESSAGERECENT,
        payload: {
            promise: api.findSigninwallMessageRecent(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: params,
            sort: sort,
            extra: extra
        }
    };
};



// WEBPACK FOOTER //
// ./src/redux/actions/signinWall.js